<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
    }
  }
}
</script>

<style lang='less'>
@import "./assets/css/reset_ant.less";
body { height: 100%; padding: 0; margin: 0;background: #edf0f4;}
*{
  font-family: "Microsoft YaHei" !important
}
.ant-tag{
  margin-bottom: 5px!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue